/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import FormTitle from "../FormTitle/FormTitle";
import FormStartBox from "./FormStartBox/FormStartBox";
import classes from "./FormStart.module.scss";
import singleTix from "../../assets/images/singleTix.png";
import largeGroupTix from "../../assets/images/largeGroupTix.png";
import packageTix from "../../assets/images/packageTix.png";
import headerBannerDesktop from "../../assets/images/homepage-banners/banner-desktop.png";
import headerBannerMobile from "../../assets/images/homepage-banners/banner-mobile.png";
import washingtonNationalsLogo from "../../assets/images/washington-nationals-logo.svg";
import * as CONSTANT from "../../constants/routes";
import * as ROUTES from "../../constants/routes";
import FormController from "../../components/FormController/FormController";
import { CMS_ASSET_URL_BASE } from "../../config";

import { useDispatch, useSelector } from "react-redux";
import { setType } from "../../features/singleGroup/singleGroupSlice";
import { getHomeBanner } from "../../features/cms/cmsSlice";

const FormStart = (props) => {
  const dispatch = useDispatch();
  const banner = useSelector(getHomeBanner);

  useEffect(() => {
    props.updateMultipleSelectedChoices({
      [ROUTES.PAGE_1_KEY]: "",
      [ROUTES.PAGE_2_KEY]: "",
      [ROUTES.PAGE_3_KEY]: "",
      // [ROUTES.PAGE_4_KEY]: {},
      [ROUTES.PAGE_5_KEY]: "",
      selectYourSeatsUuid: "",
      buid: "",
      seatInfoSelected: "",
      numOfSeat: "",
      // benefitSubmit: false
    });

    // if (props.formStart !== "") {
    if (window.adobeAnalytics) {
      setTimeout(() => {
        window.adobeAnalytics.t({
          pageName:
            "Washington Nationals: Tickets: Nationals Ticketfinder: Form Start",
        });
      }, 2000);
    }
    // }
  }, []);

  return (
    <div>
      <FormTitle title="Looking For Nationals Tickets?" />
      {banner[0].active && (
        <>
          {banner[0].title && (
            <a
              href={banner[0]?.banner_link}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className={classes.headerBanner}>
                <h2>{banner[0].title}</h2>
                <h4>{banner[0].subTitle}</h4>
                <img src={washingtonNationalsLogo} alt="" />
              </div>
            </a>
          )}
          {banner[0].desktop_image && (
            <a
              href={banner[0]?.banner_link}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className={classes.headerBannerDesktop}>
                {banner[0].desktop_image?.path && (
                  <img
                    src={`${CMS_ASSET_URL_BASE}${banner[0]?.desktop_image?.path}`}
                    alt=" "
                  />
                )}
              </div>
              <div className={classes.headerBannerMobile}>
                {banner[0].desktop_image?.path && (
                  <img
                    src={`${CMS_ASSET_URL_BASE}${banner[0]?.mobile_image?.path}`}
                    alt=" "
                  />
                )}
              </div>
            </a>
          )}
        </>
      )}
      <div className={classes.FormStartBox}>
        {/* <p className={classes.covid19}>
          After continued discussion and planning with the Government of the
          District of Columbia, health experts and Major League Baseball, we are
          excited to announce that we will be expanding to full capacity at
          Nationals Park, beginning with our June 10 game.
          <br />
          <br />
          We are on sale to fans looking to purchase new 2021 season plans!
          Since our options have changed to conform with our new seating
          capacity, please click "Chat with a Representative" below to learn
          more about our current offerings.
          <br />
          <br />
          For additional information, including Frequently Asked Questions,
          please visit{" "}
          <a
            href="http://nationals.com/2021ticketinfo"
            target="_blank"
            rel="noopener noreferrer"
          >
            nationals.com/2021ticketinfo
          </a>
          .
        </p> */}
        <FormStartBox
          icon={packageTix}
          iconStyle={{ maxWidth: "61px" }}
          title="Multi-Game <br /> Ticket Plans"
          message=""
          description=""
          buttonName="Select"
          // buttonName="Check Back Later!"
          buttonLink="style-of-plan"
          // buttonLink="https://www.mlb.com/nationals/tickets/season-tickets/plan-options/initial-payment"
          // externalLink
          updateSelectedChoices={() => {
            if (window.adobeAnalytics && window.adobeAnalytics.tl) {
              window.adobeAnalytics.tl(
                true,
                "o",
                "Washington Nationals: Tickets: Nationals Ticketfinder: Form Start: multi-game ticket plans : select button click",
                {
                  prop12: "Nationals TicketFinder",
                  prop13:
                    "Washington Nationals: Tickets: Nationals Ticketfinder: Form Start",
                  prop14: "multi-game ticket plans : select button click",
                }
              );
            }
            // enable this when adding the select back
            props.updateSelectedChoices(
              CONSTANT.PAGE_1_KEY,
              CONSTANT.PAGE_1_CHOICES_3
            );
          }}
        />
        <FormStartBox
          icon={largeGroupTix}
          iconStyle={{ maxWidth: "82px" }}
          title="Tickets for a <br /> Large Group"
          description=""
          // buttonName="Check Back Later"
          buttonName="Select"
          message=""
          externalLink="https://www.mlb.com/nationals/tickets/group-tickets"
          buttonLink="https://www.mlb.com/nationals/tickets/group-tickets"
          // externalLink="chat"
          updateSelectedChoices={() => {
            if (window.adobeAnalytics && window.adobeAnalytics.tl) {
              window.adobeAnalytics.tl(
                true,
                "o",
                "Washington Nationals: Tickets: Nationals Ticketfinder: Form Start: Tickets for a Large Group : select button click",
                {
                  prop12: "Nationals TicketFinder",
                  prop13:
                    "Washington Nationals: Tickets: Nationals Ticketfinder: Form Start",
                  prop14: "Tickets for a Large Group : select button click",
                }
              );
            }
            dispatch(setType("group"));
          }}
        />
        <FormStartBox
          icon={singleTix}
          iconStyle={{ maxWidth: "49px" }}
          title="Tickets to a <br /> Single Game"
          description=""
          // buttonName="Check Back Later"
          buttonName="Select"
          message=""
          featured={true}
          // buttonLink="ticket-single-group"
          buttonLink="https://www.mlb.com/nationals/tickets/single-game-tickets"
          externalLink="https://www.mlb.com/nationals/tickets/single-game-tickets"
          updateSelectedChoices={() => {
            if (window.adobeAnalytics && window.adobeAnalytics.tl) {
              window.adobeAnalytics.tl(
                true,
                "o",
                "Washington Nationals: Tickets: Nationals Ticketfinder: Form Start: Tickets to a Single Game : select button click",
                {
                  prop12: "Nationals TicketFinder",
                  prop13:
                    "Washington Nationals: Tickets: Nationals Ticketfinder: Form Start",
                  prop14: "Tickets to a Single Game : select button click",
                }
              );
            }
            dispatch(setType("single"));
          }}
        />

        {/* <FormStartBox
          icon={singleTix}
          iconStyle={{ maxWidth: "49px" }}
          title="Tickets to a<br />Single Game"
          description="Choose your game from a season full of exciting giveaways, theme games, and special promotions."
          buttonName="Stay tuned"
          buttonLink="https://www.mlb.com/nationals/tickets/single-game-tickets?affiliateId=was-ticketfinder-041221"
          externalLink={true}
          updateSelectedChoices={() => {
            if (window.adobeAnalytics && window.adobeAnalytics.tl) {
              window.adobeAnalytics.tl(
                true,
                "o",
                "Washington Nationals: Tickets: Nationals Ticketfinder: Form Start: Tickets to a Single Game : select button click",
                {
                  prop12: "Nationals TicketFinder",
                  prop13:
                    "Washington Nationals: Tickets: Nationals Ticketfinder: Form Start",
                  prop14: "Tickets to a Single Game : select button click",
                }
              );
            }
            // props.updateSelectedChoices(
            //   CONSTANT.PAGE_1_KEY,
            //   CONSTANT.PAGE_1_CHOICES_1
            // );
          }}
        /> */}
        {/* <p className={classes["covid19--no-border"]}>
          <span className={classes.covid19_2}>
            Use your FREE 50% Bonus Credit* on concessions, merchandise,
            additional tickets and more!
          </span>
        </p>
        <p className={classes["covid19--no-border"]}>
          *50% Bonus Credit calculated based on the amount paid towards
          qualifying new 2021 ticket plans on or before December 15, 2020, less
          all associated fees. For 50% Bonus Credit program terms & conditions,
          please visit{" "}
          <a
            href="http://www.nationals.com/bonusterms"
            target="_blank"
            rel="noopener noreferrer"
          >
            www.nationals.com/bonusterms
          </a>
          .
        </p> */}
      </div>
      <FormController
        backTo={ROUTES.PAGE_1_LINK}
        nextTo={ROUTES.PAGE_3_LINK}
        startOver={ROUTES.PAGE_1_LINK}
        showBack={false}
        showStartOver={false}
        showSkip={false}
        showSubmit={false}
      />
    </div>
  );
};

export default FormStart;
